// Lightweight reverse-geocoder backed by Nominatim (OSM). Free, no key.
// We're well under any reasonable rate cap because calls only spawn every ~90s.

const cache = new Map();

const ENDPOINT = "https://nominatim.openstreetmap.org/reverse";

const fallbackForUSCity = (cityName) => {
  // Used while waiting for the network call to come back, or if it fails.
  const num = Math.floor(100 + Math.random() * 9800);
  const streets = [
    "Main St", "Oak Ave", "Maple Dr", "5th Ave", "Broadway", "Cedar Ln",
    "Elm St", "Pine Rd", "Sunset Blvd", "Lake Dr", "Park Ave", "Hill St",
    "King St", "Washington St", "Jefferson Ave",
  ];
  const st = streets[Math.floor(Math.random() * streets.length)];
  return `${num} ${st}, ${cityName}`;
};

// Format an OSM address object into a short "street, city, state" string
const formatAddress = (osm) => {
  const a = osm.address || {};
  const street = [a.house_number, a.road].filter(Boolean).join(" ");
  const place = a.city || a.town || a.village || a.hamlet || a.suburb || a.neighbourhood;
  const state = a.state || a.region;
  const parts = [street || a.road || a.pedestrian || a.amenity, place, state].filter(Boolean);
  if (parts.length === 0) {
    // last-resort: trim the full display_name to first 3 segments
    const split = (osm.display_name || "").split(",").map((s) => s.trim()).filter(Boolean);
    return split.slice(0, 3).join(", ");
  }
  return parts.join(", ");
};

export async function reverseGeocode(lat, lng) {
  const key = `${lat.toFixed(5)},${lng.toFixed(5)}`;
  if (cache.has(key)) return cache.get(key);
  try {
    const url = `${ENDPOINT}?lat=${lat}&lon=${lng}&format=jsonv2&zoom=18&addressdetails=1`;
    const ctrl = new AbortController();
    const tid = setTimeout(() => ctrl.abort(), 5000);
    const r = await fetch(url, { signal: ctrl.signal, headers: { Accept: "application/json" } });
    clearTimeout(tid);
    if (!r.ok) throw new Error(`nominatim ${r.status}`);
    const j = await r.json();
    const addr = formatAddress(j);
    if (addr) {
      cache.set(key, addr);
      return addr;
    }
    return null;
  } catch (e) {
    return null;
  }
}

export { fallbackForUSCity };
